<template>
  <div>
    <van-nav-bar
      title="入库"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      fixed
    />
    <div class="psiConfirmCont">
      <div style="display: flex;">
        <van-field
          v-if = "showPosition"
          v-model="position"
          center
          clearable
          autofocus
          ref="positionInput"
          label="货位"
          placeholder="请输入货位条码"
        >
        </van-field>
      </div>
      <div style="display: flex;">
        <van-field
          v-model="value"
          center
          clearable
          label="条码"
          ref="barcodeInput"
          placeholder="请输入条码"
        >
          <template #button>
            <van-button size="small" type="info" @click="confirm"
              >确定</van-button
            >
          </template>
        </van-field>
      </div>
      <div class="psiDetailCont">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            @load="onLoad"
            finished-text="没有更多了"
          >
            <div v-for="item in list" class="card" :key="item.uuid">
              <template>
                <table class="layout">
                  <tr>
                    <td>{{ item.produceOrderNo }}</td>
                    <td>{{ item.produceCustomerId }}</td>
                    <td>{{ item.inputTime }}</td>
                  </tr>
                  <tr v-for="obj in item.details" :key="obj.field1">
                    <td>{{obj.field1}}</td>
                    <td>{{obj.field2}}</td>
                    <td>{{obj.field3}}</td>
                  </tr>
                  <tr>
                    <td>{{ item.barcode }}</td>
                    <td>{{ item.positionname }}</td>
                  </tr>
                </table>
              </template>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
      <div class="recordBox">
        <table
          style="background-color: #1989fa;width: 100%;margin-bottom: 3px;"
        >
          <tr style="height:40px;">
            <td v-if="showPosition" style="width: 20%;color:white;text-align: center;">货位:</td>
            <td v-if="showPosition" style="width: 40%;color:white;">{{ position }}</td>
            <td style="width: 20%;color:white;">已扫码:</td>
            <td style="width: 20%;color:white;">{{ quantity }}</td>
          </tr>
        </table>

        <van-button type="info" size="large" @click="goList"
          >扫码记录</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { NavBar, Field, Button, List, PullRefresh, Toast } from "vant";
import barcodeService from "../../service/barcodeService";
import configService from "../../service/configService";
import { formatDictionary } from "../../utils/dictionary";
import moment from "moment";

export default {
  data() {
    return {
      position: "",
      value: "",
      tempPosition: "",
      tempValue: "",
      positionId: "",
      type: "",
      quantity: 0,
      barcodeIds: ["0"],
      list: [],
      loading: false,
      finished: false,
      pageIndex: 0,
      refreshing: false,
      fields:[],
      dictNames: "",
      showPosition: true
    };
  },
  mounted: async function() {
    let resp = await configService.getConfigByName("扫码入库显示货位输入框");
    if (resp.data.Status === "1"){
      if (resp.data.Data && resp.data.Data.value === "否"){
        this.showPosition = false;
      }
    }

    if(this.showPosition){
      this.$refs.positionInput.focus();
    }else{
      this.$refs.barcodeInput.focus();
    }

    this.type = this.$route.query.type;
    let that = this;
    document.onkeydown = function(event) {
      if (event.keyCode == 13) {
        that.tempPosition = that.position;
        that.tempValue = that.value;
        /*if(that.tempPosition.length > 0){
          if(that.tempPosition.indexOf("HW") < 0 && that.positionId.indexOf("HW") < 0){
            that.value = that.tempPosition;
            this.position = "";
          }
        }*/
        if(that.tempValue.length > 0){
          if(that.tempValue.indexOf("HW") > -1){
            that.position = that.tempValue;
            that.value = "";
          }
        }
        if ((that.position.length > 0 && that.value.length == 0)
              || (!that.showPosition && that.value.length == 0)) {
          that.$refs.barcodeInput.focus();
        } else {
          that.confirm();
        }
      }
    };
  },
  components: {
    [NavBar.name]: NavBar,
    [Field.name]: Field,
    [Button.name]: Button,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    goList() {
      this.$router.push({ path: "inputDetail" });
    },
    async confirm() {
      if(!this.value){
        return ;
      }
      //alert("条码号" + this.value);
      let resp = await barcodeService.storage(this.value, this.position);
      if (resp.data.Status === "1") {
        this.barcodeIds.push(resp.data.Data);
        Toast.success("扫码入库成功");
        this.value = "";
        this.$refs.barcodeInput.focus();
        this.quantity++;
        this.onRefresh();
      } else {
        /*if(this.showPosition){
          top.location.href = "/audio/alert";
        }*/
        Toast.fail(resp.data.Message);
        this.value = "";
        if (this.position.length == 0 && this.showPosition) {
          this.$refs.positionInput.focus();
        } else {
          this.$refs.barcodeInput.focus();
        }

      }
    },
    async onLoad() {
      if(this.dictNames == ""){
        let resp = await barcodeService.getBarcodeFieldList();
        if (resp.data.Status == "1") {
          this.fields = resp.data.Data;
          if(this.fields.length > 0){
            let tempDict = "position.rad_position";
            this.fields.forEach(item => {
              if(item.type == "6"){
                tempDict += ",";
                tempDict += item.name;
                tempDict+= ".";
                tempDict += item.dictName;
              }
            });
            this.dictNames = tempDict;
          }else{
            this.dictNames = "radId.rad_sku,radCategory.rad_sku_category,centerCategory.dict_rad_center_category,caliber.dict_rad_caliber,color.dict_rad_color,waterFlow.dict_rad_flowin_method,position.rad_position";
          }
        }
      }
      this.pageIndex++;
      let resp = await barcodeService.getInputList(
        this.pageIndex,
        this.barcodeIds.join(","),
        this.dictNames
      );
      resp.data.Data.data.forEach(item => {
        item.inputTime = moment(item.inputTime).format("YYYY-MM-DD");
      });
      formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
      resp.data.Data.data.forEach(item => {
        let details = [];
        if(this.fields.length > 0){
          let length = this.fields.length;
          let detailItem = {};
          this.fields.forEach(function (obj, i) {
            if(obj.name == "pieces"){
              item[obj.name] = (item[obj.name] || "") + "片";
            }
            if(i%3 == 0){
              detailItem = {};
              if(obj.type == "6"){
                detailItem.field1 = item[obj.name+"name"] || "";
              }else{
                detailItem.field1 = item[obj.name] || "";
              }
              if(i == length -1){
                details.push(detailItem);
              }
            }
            if(i%3 == 1){
              if(obj.type == "6"){
                detailItem.field2 = item[obj.name+"name"] || "";
              }else{
                detailItem.field2 = item[obj.name] || "";
              }
              if(i == length -1){
                details.push(detailItem);
              }
            }
            if(i%3 == 2){
              if(obj.type == "6"){
                detailItem.field3 = item[obj.name+"name"] || "";
              }else{
                detailItem.field3 = item[obj.name] || "";
              }
              details.push(detailItem);
            }
          });
        }else{
          details.push({
            field1: item.radCategoryname,
            field2: item.radIdname,
            field3: item.pieces + "片"
          });
          details.push({
            field1: item.centerCategoryname,
            field2: item.centerSpacing,
            field3: item.calibername
          });
          details.push({
            field1: item.colorname,
            field2: item.waterFlowname,
            field3: item.isSpecials || ""
          });
        }
        item.details = details;
      });
      this.loading = false;
      this.refreshing = false;
      this.list = [...this.list, ...resp.data.Data.data];
      this.finished = resp.data.Data.total <= this.list.length;
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.pageIndex = 0;
      this.list = [];
      this.onLoad();
    }
  },
  watch: {
    async position() {
      let resp = await barcodeService.getPositionById(this.position);
      if (resp.data.Status === "1") {
        this.position = resp.data.Data.name;
        this.positionId = resp.data.Data.uuid;
        this.quantity = 0;
      }
    }
  }
};
</script>

<style scoped>
.psiConfirmCont {
  width: 100%;
  margin: 0 auto;
  margin-top: 120px;
  overflow: hidden;
}
.btnBox {
}
.recordBox {
  padding: 0.5rem 0;
  box-sizing: border-box;
  margin-top: 2rem;
  bottom: 0;
  position: fixed;
  width: 100%;
}
.psiDetailCont {
  width: 100%;
  margin: 0 auto;
  margin-top: 20px;
}
</style>
